import React from "react";
import { isMobile } from "react-device-detect";
import { useQuery } from "@apollo/client";
import DesktopHeader from "../../Header/DesktopHeader";
import MobileHeader from "../../Header/MobileHeader";
import DeskFooter from "../DeskFooter";
import MobileFooter from "../MobileFooter";
import SeoManager from "../../seoManager";

import { FAQ } from "../../../gqlOperations/queries";

export default function FAQs() {
  // document.title = "KheloMore FAQs | Sports Booking & Coaching Help Center";

  const { loading, error, data } = useQuery(FAQ);
  const htmlData = data?.faqs?.data.map(
    (details) => details?.attributes?.Value,
  );
  return (
    <>
      <SeoManager
        pageTitle="KheloMore FAQs | Sports Booking & Coaching Help Center"
        description="Find answers about KheloMore bookings, payments, sports coaching, cancellations, venues, refunds, and account management in our FAQ section."
      />
      {isMobile ? (
        <div>
          <MobileHeader />
          <div dangerouslySetInnerHTML={{ __html: htmlData }} />
          <MobileFooter />
        </div>
      ) : (
        <div>
          <DesktopHeader />
          <div>
            <div dangerouslySetInnerHTML={{ __html: htmlData }} />
          </div>
          <DeskFooter />
        </div>
      )}
    </>
  );
}
